import { TableCell, TableRow } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Currency from 'src/components/elements/formats/Currency';
import { useNumberFormat, usePercentFormat } from 'src/core/hooks/format';
import { DiscountEntry } from 'src/entities/volume-discount/Discounts';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '& [class*="MuiTableCell-root"]:first-child': {
        width: '40%',
    },
    '&[data-active="true"] [class*="MuiTableCell-root"]': {
        color: theme.palette.success.main,
        fontWeight: theme.typography.fontWeightBold,
        border: 'none',
    },
}));

interface VolumeDiscountTableRowProps {
    discount: DiscountEntry & { active?: boolean };
    basePrice?: number;
    currencyIso?: string;
}

export const VolumeDiscountTableRow: FC<VolumeDiscountTableRowProps> = ({ discount, basePrice, currencyIso }) => {
    const { t } = useTranslation();
    const formatPercent = usePercentFormat()();
    const formatColli = useNumberFormat()({
        postfix: discount.colli,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    });

    return (
        <StyledTableRow data-active={discount.active ? 'true' : undefined}>
            <TableCell>
                {t('shop.volume_discount.from', {
                    amount: formatColli(discount.minQuantity),
                })}
            </TableCell>
            {basePrice ? (
                <TableCell>
                    <Currency amount={basePrice - basePrice * discount.value} currencyIso={currencyIso} /> (
                    {formatPercent(discount.value)})
                </TableCell>
            ) : (
                <TableCell>{formatPercent(discount.value)}</TableCell>
            )}
        </StyledTableRow>
    );
};
